import React from 'react';

// Lo usamos en muchos formularios, así que lo aislamos
export const InputField = ({ icon, label, containerClassName, ...props }) => (
    <div className={containerClassName}>
        {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
        <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                {icon ? React.cloneElement(icon, { className: 'h-5 w-5 text-gray-400' }) : null}
            </div>
            <input 
                {...props}
                className={`w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${props.readOnly ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            />
        </div>
    </div>
);

// El modal se usa en varias partes, así que lo aislamos
export const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
                {children}
            </div>
        </div>
    );
};

// La tarjeta de estadística es exclusiva del Dashboard, pero la separamos para mantener el orden
export const StatCard = ({ title, value, icon, variant, loading }) => {
    const colorVariants = {
        yellow: 'bg-yellow-500',
        red: 'bg-red-500',
        green: 'bg-green-500',
        blue: 'bg-blue-500',
    };
    const bgColor = colorVariants[variant] || 'bg-gray-500';

    return (
        <div className={`p-6 rounded-lg shadow-lg flex items-center justify-between ${bgColor}`}>
            <div>
                <p className="text-sm font-medium text-white uppercase">{title}</p>
                {loading ? (
                    <div className="h-8 w-24 bg-white/30 animate-pulse rounded-md mt-2"></div>
                ) : (
                    <p className="text-3xl font-bold text-white">{value}</p>
                )}
            </div>
            <div className="text-white opacity-70">
                {icon}
            </div>
        </div>
    );
};